var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fixedWidth)?_c('div',{staticClass:"w-100 d-flex align-items-center justify-content-center"},[_c('span',{staticClass:"countdown-digital"},[_vm._v(" "+_vm._s(_vm.displayRemainingTime)+" ")])]):_c('span',{staticClass:"countdown-digital"},[_vm._v(" "+_vm._s(_vm.displayRemainingTime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }